const PeerQuikPromo: React.FC = () => {
  return (
    <section className="bg-gradient-to-br from-cyan-900/30 via-gray-900 to-black text-white py-20 px-4 border-y border-cyan-400/30">
      <div className="max-w-4xl mx-auto">
        {/* Badge superior */}
        <div className="flex justify-center mb-6">
          <div className="inline-block bg-cyan-400/20 border border-cyan-400/50 rounded-full px-5 py-2">
            <span className="text-cyan-400 text-sm font-bold uppercase tracking-wider">
              ✨ Want the Full Boilerplate?
            </span>
          </div>
        </div>

        {/* Título principal */}
        <h2 className="text-3xl md:text-5xl font-extrabold mb-6 text-center leading-tight">
          This Code is Part of
          <span className="text-cyan-400"> PeerQuik</span>
        </h2>

        <p className="text-xl text-gray-200 mb-8 text-center max-w-2xl mx-auto leading-relaxed">
          The complete Next.js boilerplate with <strong>everything you need</strong> to launch your SaaS or marketplace—including auth, payments, admin dashboards, and more.
        </p>

        {/* <p className="text-xl text-gray-200 mb-8 text-center max-w-2xl mx-auto leading-relaxed">
          The complete Next.js boilerplate with <strong>everything you need</strong> to launch your SaaS or marketplace—including this exact referral system, plus auth, payments, admin dashboards, and more.
        </p> */}

        {/* Features grid */}
        {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10"> */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
          <div className="bg-black/50 rounded-lg p-4 border border-gray-800 text-center">
            <p className="text-cyan-400 font-bold text-sm">Auth Ready</p>
          </div>
          <div className="bg-black/50 rounded-lg p-4 border border-gray-800 text-center">
            <p className="text-cyan-400 font-bold text-sm">Stripe Built-in</p>
          </div>
          <div className="bg-black/50 rounded-lg p-4 border border-gray-800 text-center">
            <p className="text-cyan-400 font-bold text-sm">Admin Dashboard</p>
          </div>
          {/* <div className="bg-black/50 rounded-lg p-4 border border-gray-800 text-center">
            <p className="text-cyan-400 font-bold text-sm">Referrals System</p>
          </div> */}
        </div>

        {/* CTA grande */}
        <div className="text-center">
          <a
            href="/"
            className="inline-block bg-cyan-400 hover:bg-cyan-300 hover:text-black text-black font-bold py-4 px-10 rounded-full text-lg transition-all hover:scale-105 shadow-lg shadow-cyan-400/30"
          >
            Explore PeerQuik Boilerplate →
          </a>
          <p className="text-sm text-gray-400 mt-4">
            Skip months of setup. Ship your SaaS in days, not weeks.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PeerQuikPromo;
